module.exports = __webpack_public_path__ + "img/galactica_blueprints_10.70152451.png";